export default __webpack_public_path__ + "static/media/TropomiDE.7f3787a6.svg";